import { FeatureFlag } from 'feature-flags'
import { useCallback, useEffect, useState } from 'react'
import { featureFlagManager } from 'utils/feature-flag-manager'
import { useTenantId } from 'utils/useTenantId'

export const useFeatureFlag = (
  userId: string,
  flagName: FeatureFlag,
  callback?: (flagValue: boolean) => void
) => {
  const [enableFeatureFlag, setEnableFeatureFlag] = useState<boolean | undefined>(undefined)
  const tenantId = useTenantId()

  const checkFeatureFlag = useCallback(async () => {
    try {
      const flagValue = await featureFlagManager.checkToggleFlag(flagName, userId, tenantId)
      setEnableFeatureFlag(flagValue)
      if (callback) callback(flagValue)
    } catch (error) {
      console.error('Error checking feature flag:', error)
      setEnableFeatureFlag(false)
      if (callback) callback(false)
    }
  }, [userId, flagName, tenantId, callback])

  useEffect(() => {
    checkFeatureFlag()
  }, [checkFeatureFlag])

  return enableFeatureFlag
}
